import { render, staticRenderFns } from "./AddStudentForm.vue?vue&type=template&id=57bfb5ae&scoped=true&"
import script from "./AddStudentForm.vue?vue&type=script&lang=js&"
export * from "./AddStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentForm.vue?vue&type=style&index=0&id=57bfb5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfb5ae",
  null
  
)

export default component.exports